import { MemberResponseInterface } from '@careapp/angular-sdk';

import { CAAction } from '../actions';
import { Staff } from '../actions/index';
import { DataListState } from './data-list.state';
import { ReducerStateFactory } from './state-factory.reducer';

class StaffState extends ReducerStateFactory<MemberResponseInterface> {
  constructor() {
    super(Staff);
  }
  public reducer(
    state: DataListState<MemberResponseInterface> = this.initialState,
    action: CAAction
  ) {
    switch (action.type) {
      case Staff.REQUEST_UPDATE_ROLE:
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [action.payload.id]: true }
        };
      case Staff.RESPONSE_SUCCESS_UPDATE_ROLE:
        const member = { ...state.entities[action.payload.memberId] };
        member.permissions = [action.payload];
        const entities = { ...state.entities, [member.id]: member };
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [member.id]: false },
          entities
        };
      case Staff.RESPONSE_FAIL_UPDATE_ROLE:
        return {
          ...state,
          loadingEntities: { ...state.loadingEntities, [action.payload.id]: false }
        };
    }
    return super.reducer(state, action);
  }
}

export const state = new StaffState();

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
